"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var observe_rect_1 = __importDefault(require("@reach/observe-rect"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var react_confetti_1 = __importDefault(require("react-confetti"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var Configuration_1 = require("Styles/Configuration/Configuration");
var styles = __importStar(require("./TailoredPageTourPrompt.css"));
var caretSize = 8;
var TailoredPageTourPrompt = function (_a) {
    var targetElement = _a.targetElement, tooltipPosition = _a.tooltipPosition, _b = _a.tooltipOffset, tooltipOffset = _b === void 0 ? 8 : _b, transitionStatus = _a.transitionStatus, title = _a.title, emoji = _a.emoji, body = _a.body, buttonText = _a.buttonText, promptIndex = _a.promptIndex, promptCount = _a.promptCount, _c = _a.confetti, confetti = _c === void 0 ? false : _c, onAcceptPrompt = _a.onAcceptPrompt, onDismissPrompt = _a.onDismissPrompt, onGoToPrompt = _a.onGoToPrompt;
    var overlayRef = (0, react_1.useRef)(null);
    var _d = __read((0, react_1.useState)(), 2), targetRect = _d[0], setTargetRect = _d[1];
    var _e = __read((0, react_1.useState)(), 2), overlayRect = _e[0], setOverlayRect = _e[1];
    var _f = __read((0, react_1.useState)(confetti), 2), showConfetti = _f[0], setShowConfetti = _f[1];
    var _g = __read((0, react_1.useState)(false), 2), showRipple = _g[0], setShowRipple = _g[1];
    (0, react_1.useEffect)(function () {
        var timer = setTimeout(function () {
            setShowConfetti(false);
        }, 1000);
        return function () { return clearTimeout(timer); };
    }, []);
    (0, react_1.useLayoutEffect)(function () {
        if (!targetElement || !overlayRef.current) {
            return;
        }
        var targetRectObserver = (0, observe_rect_1.default)(targetElement, setTargetRect);
        var overlayRectObserver = (0, observe_rect_1.default)(overlayRef.current, setOverlayRect);
        targetRectObserver.observe();
        overlayRectObserver.observe();
        return function () {
            targetRectObserver.unobserve();
            overlayRectObserver.unobserve();
        };
    }, [targetElement, overlayRef]);
    var overlayProps = (0, react_1.useMemo)(function () {
        return (0, utils_1.getOverlayPosition)({
            position: tooltipPosition,
            offset: tooltipOffset,
            caretSize: caretSize,
            targetRect: targetRect,
            overlayRect: overlayRect,
        });
    }, [tooltipPosition, tooltipOffset, targetRect, overlayRect]);
    var onClickOutside = function () {
        setShowRipple(true);
    };
    return (react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.promptZIndex }, function () {
        var _a;
        var _b, _c;
        return (react_1.default.createElement("div", { className: "tour-prompt" },
            react_1.default.createElement(react_confetti_1.default, { confettiSource: {
                    x: overlayProps.overlay.left,
                    y: overlayProps.overlay.top,
                    w: (_b = overlayRect === null || overlayRect === void 0 ? void 0 : overlayRect.width) !== null && _b !== void 0 ? _b : 0,
                    h: (_c = overlayRect === null || overlayRect === void 0 ? void 0 : overlayRect.height) !== null && _c !== void 0 ? _c : 0,
                }, colors: ["#716BF1", "#0BDAC9", "#FFB961"], recycle: false, numberOfPieces: showConfetti ? 200 : 0, drawShape: function (ctx) {
                    ctx.beginPath();
                    ctx.rect(0, 0, 6, 12);
                    ctx.fill();
                } }),
            react_1.default.createElement("div", { className: styles.backdrop, onClick: onClickOutside }),
            react_1.default.createElement("div", { className: styles.overlay({ status: transitionStatus }), ref: overlayRef, style: __assign({}, overlayProps.overlay) },
                react_1.default.createElement(kaleidoscope_1.Card, { className: styles.card, elevation: 2 },
                    react_1.default.createElement("div", { className: styles.closeButton },
                        react_1.default.createElement(kaleidoscope_1.IconButton, { "aria-label": "Dismiss", onClick: onDismissPrompt, icon: react_1.default.createElement(icons_1.Close, null), isRound: true })),
                    react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "m" },
                        emoji && react_1.default.createElement("div", { className: styles.emoji }, emoji),
                        react_1.default.createElement("div", { className: styles.content },
                            react_1.default.createElement(kaleidoscope_1.Heading, { level: "3", strong: true, className: styles.text }, title),
                            body)),
                    react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "spaceBetween", align: "end", paddingTop: "xl" },
                        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal" }, Array.from({ length: promptCount }).map(function (_, index) { return (react_1.default.createElement("button", { key: index, className: styles.control, onClick: function () { return onGoToPrompt(index); }, "aria-label": "Go to prompt ".concat(index + 1), disabled: promptIndex === index },
                            react_1.default.createElement("div", { className: styles.dot({ active: promptIndex === index }) }))); })),
                        react_1.default.createElement("div", { className: styles.buttonWrapper },
                            react_1.default.createElement(kaleidoscope_1.Button, { onClick: onAcceptPrompt }, buttonText),
                            showRipple && react_1.default.createElement("div", { className: styles.ripple, onAnimationEnd: function () { return setShowRipple(false); } }))),
                    react_1.default.createElement("div", { className: styles.caret({ position: overlayProps.modifier, status: transitionStatus }), style: (0, dynamic_1.assignInlineVars)((_a = {},
                            _a[styles.caretSize] = "".concat(caretSize, "px"),
                            _a[styles.caretTop] = "".concat(overlayProps.caret.top, "px"),
                            _a[styles.caretLeft] = "".concat(overlayProps.caret.left, "px"),
                            _a)) })))));
    }));
};
exports.default = TailoredPageTourPrompt;
